import { getRequirementTypeSortIndex } from './requirementType';

export const PRIORITY_NO_VALUE_SORT_INDEX = 6;

export function getPriorityDisplayLabel(priority) {
  const normalized = normalizeRequirementPriority(priority);
  if (normalized === null) return null;
  return `${normalized} - Priority P${normalized}`;
}

export const PRIORITY_SELECT_OPTIONS = [
  { value: '', label: 'No Priority' },
  { value: '1', label: '1 - Priority P1' },
  { value: '2', label: '2 - Priority P2' },
  { value: '3', label: '3 - Priority P3' },
  { value: '4', label: '4 - Priority P4' },
  { value: '5', label: '5 - Priority P5' },
];

export function normalizeRequirementPriority(priority) {
  if (priority === null || priority === undefined || priority === '') {
    return null;
  }

  const numeric = Number(priority);
  if (!Number.isInteger(numeric) || numeric < 1 || numeric > 5) {
    return null;
  }

  return numeric;
}

export function getPrioritySortIndex(priority) {
  const normalized = normalizeRequirementPriority(priority);
  if (normalized === null) return PRIORITY_NO_VALUE_SORT_INDEX;
  return normalized;
}

export function formatPriorityLabel(priority) {
  const label = getPriorityDisplayLabel(priority);
  if (label === null) return '—';
  return label;
}

export function formatPriorityShortLabel(priority) {
  const normalized = normalizeRequirementPriority(priority);
  if (normalized === null) return null;
  return `P${normalized}`;
}

export function sortByPriorityThenUploadedDate(
  items,
  getPriority = (item) => item?.priority,
  getUploadedDate = (item) => item?.uploadedDate,
) {
  return [...items].sort((a, b) => {
    const priorityDiff = getPrioritySortIndex(getPriority(a)) - getPrioritySortIndex(getPriority(b));
    if (priorityDiff !== 0) return priorityDiff;
    return new Date(getUploadedDate(b) || 0) - new Date(getUploadedDate(a) || 0);
  });
}

/** Admin / TL requirement lists: High → Medium → Low, then P1–P5 → No Priority. */
export function sortByRequirementTypeThenPriority(
  items,
  getType = (item) => item?.requirementtype,
  getPriority = (item) => item?.priority,
  getUploadedDate = (item) => item?.uploadedDate,
) {
  return [...items].sort((a, b) => {
    const typeDiff = getRequirementTypeSortIndex(getType(a)) - getRequirementTypeSortIndex(getType(b));
    if (typeDiff !== 0) return typeDiff;
    const priorityDiff = getPrioritySortIndex(getPriority(a)) - getPrioritySortIndex(getPriority(b));
    if (priorityDiff !== 0) return priorityDiff;
    return new Date(getUploadedDate(b) || 0) - new Date(getUploadedDate(a) || 0);
  });
}

export function getPriorityBadgeClass(priority) {
  const normalized = normalizeRequirementPriority(priority);
  if (normalized === null) return 'hr-priority-badge hr-priority-none';
  return `hr-priority-badge hr-priority-p${normalized}`;
}
